import script from "./CookieWall.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieWall.vue?vue&type=script&setup=true&lang=js"

import "./CookieWall.vue?vue&type=style&index=0&id=26aaba98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26aaba98"]])

export default __exports__